var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "106.1px",
    height: "106.289px",
    viewBox: "74.65 17.75 106.1 106.289",
    enableBackground: "new 74.65 17.75 106.1 106.289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 38.5,
    fill: "#8DC63F",
    width: 66,
    height: 65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-plus",
    fill: "#FFFFFF",
    d: "M127.5,17.75c-29.409,0-53.25,23.841-53.25,53.25s23.841,53.25,53.25,53.25 s53.25-23.841,53.25-53.25C180.718,41.604,156.896,17.782,127.5,17.75z M154.125,75.438c0,2.451-1.986,4.438-4.438,4.438h-13.313 v13.313c0,2.451-1.985,4.438-4.438,4.438h-8.875c-2.451,0-4.438-1.986-4.438-4.438V79.875H105.31c-2.451,0-4.438-1.986-4.438-4.438 v-8.875c0-2.451,1.987-4.438,4.438-4.438h13.313V48.813c0-2.451,1.987-4.438,4.438-4.438h8.875c2.451,0,4.438,1.987,4.438,4.438 v13.313h13.313c2.451,0,4.438,1.987,4.438,4.438V75.438z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGreen);
export default __webpack_public_path__ + "static/media/plus_green.cb8b4101a97eb4d83263d1833d7ccfae.svg";
export { ForwardRef as ReactComponent };